import type { AddSSHKeyResponse } from 'api/account/handlers/addSSHKeyHandler';
import type { DeleteSSHKeyResponse } from 'api/account/handlers/deleteSSHKeyHandler';
import type { AddSSHKeyRequest } from 'common/account/SaveProfileDocuments';
import type { DeleteSSHKeyRequest } from 'common/account/SaveProfileDocuments';
import Api from 'client/lib/Api';

export const validatePublicKey = (publicKey: string) => {
  if (publicKey.length < 16) return true;
  if (publicKey.includes('PRIVATE KEY')) return false;
  if (publicKey.includes('ssh-')) return true;
  if (publicKey.includes('sha2-')) return true;
  return false;
};

export const addSSHKey = (request: AddSSHKeyRequest) => Api.post<AddSSHKeyRequest, AddSSHKeyResponse>('/profile/ssh-key/add', request);

export const deleteSSHKey = (request: DeleteSSHKeyRequest) =>
  Api.post<DeleteSSHKeyRequest, DeleteSSHKeyResponse>('/profile/ssh-key/delete', request);
